import { SWRConfiguration } from "swr";
import { useRoute } from "wouter";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useCompareHash } from "../blocks/Tires/TiresCompareDialog/TireCompareDialog";
import { partTypeTire } from "../constants/partTypes";
import { DealerComparePrintRoute } from "../navigation/DealerRoutes";
import { useDealerId } from "../stores/hooks/useDealerId";
import { MandatoryLineItem } from "../stores/slices/cartSlice";
import { TirePartItem } from "./useSearchTiresByVehicle";

export const useBuildComparison = (
  compareIds: string[],
  swrOptions: SWRConfiguration<FetcherResult<Payload>> = {}
): ModifiedSWRResponse<FetcherResult<Payload>, Payload> => {
  const dealerId = useDealerId();
  const [isVisible] = useCompareHash();
  const partId = compareIds.join(",");
  const [isPrintRoute] = useRoute(DealerComparePrintRoute);
  const shouldFetch = Boolean(partId) && (isVisible || isPrintRoute);
  const results = useSwrGet<Payload>(
    shouldFetch
      ? "/retailSiteWebService/parts/comparison/buildComparison.php"
      : null,
    {
      dealerId,
      partId,
      partType: partTypeTire,
    },
    swrOptions
  );

  return results;
};

type Payload = {
  compareResults: CompareResults[];
};

export type CompareResults = {
  part: TirePartItem;
  partQuantity: {
    [key: string]: ComparePricingContext;
  };
};

export type ComparePricingContext = {
  contextList: ComparePricingContextItem[];
  quantity: string;
};

export type ComparePricingContextItem = {
  grandTotal: string;
  itemTotal: string;
  lineItemList: MandatoryLineItem[];
  lineItemTotal: string;
  pricingContextId: string;
  subTotal: string;
  taxPercent: string;
  taxTotal: string;
};
